import { Divider, Grid, Stack, Typography } from "@mui/material";
import { StandardCellList } from "../../../../components/Standards";
import React from "react";
import { useDispatchWrapper } from "../../../../hooks";
import { IStoreState } from "../../../../redux/initialStoreState";
import { useSelector } from "react-redux";
import { formatDate, formatTime } from "../../../../helpers";
import { PageLoader } from "../../../../components/PageLoader/PageLoader";
import { LoadState } from "../../../../constants/enums";
import { ITaskPaymentAuth } from "../../../../redux/taskPaymentMethod/taskPaymentMethods.types";
import { fetchTaskPaymentAuthAsync } from "../../../../redux/taskPaymentMethod/taskPaymentMethodsActions";
import { ITaskFileUploadAttachment } from "../../../../redux/tasks/task.types";
import { StandadCard } from "../../../../components/Cards";
import { FileUpload } from "../../../../components/FileUpload/FileUpload";

export const ViewPaymentTransaction: React.FC<{
  taskCode: string;
  attachment: ITaskFileUploadAttachment[];
}> = (props) => {
  const { taskCode, attachment } = props;
  const { data, loading } = useSelector(
    (storeState: IStoreState) =>
      storeState.tasks.paymentMethods.paymentAuthorization
  );
  const dispatch = useDispatchWrapper();
  const [taskDetails, setTaskDetails] = React.useState<ITaskPaymentAuth>();

  React.useEffect(() => {
    dispatch(fetchTaskPaymentAuthAsync(taskCode));
  }, [taskCode]);

  React.useEffect(() => {
    if (data) {
      setTaskDetails(data);
    }
  }, [data]);

  return (
    <PageLoader loading={loading === LoadState.InProgress}>
      {taskDetails && (
        <Grid container spacing={1} sx={{ mt: 2 }}>
          <Grid item xs={12} lg={12}>
            <StandardCellList
              heading="Credit Card Information"
              colSize={2.3}
              list={[
                {
                  heading: "PAC Form",
                  data: {
                    type: "text",
                    value: taskDetails.pac_form,
                  },
                },
                {
                  heading: "Void Cheque",
                  data: {
                    type: "text",
                    value: taskDetails.void_cheque,
                  },
                },
                {
                  heading: "CC #",
                  data: {
                    type: "text",
                    value: taskDetails.cc,
                  },
                },
                {
                  heading: "Expiry",
                  data: {
                    type: "text",
                    value: formatDate(taskDetails.cc_expiry),
                  },
                },
                {
                  heading: "CCV",
                  data: {
                    type: "text",
                    value: taskDetails.ccv,
                  },
                },
              ]}
            />
          </Grid>
          <Grid item xs={12} lg={12}>
            <StandardCellList
              heading="Bank Information Information"
              colSize={3}
              list={[
                {
                  heading: "Name",
                  data: {
                    type: "text",
                    value: taskDetails.bank_name,
                  },
                },
                {
                  heading: "Address",
                  colSize: 9,
                  data: {
                    type: "text",
                    value:
                      taskDetails.bank_address +
                      " " +
                      taskDetails.bank_unit_or_suite +
                      " " +
                      taskDetails.bank_city +
                      " " +
                      taskDetails.bank_province_or_state +
                      " " +
                      taskDetails.bank_country +
                      " " +
                      taskDetails.bank_postal_code,
                  },
                },
              ]}
            />
          </Grid>
          <Grid item xs={12} lg={12}>
            <StandardCellList
              heading="Account Holder Information"
              colSize={3}
              list={[
                {
                  heading: "Name",
                  data: {
                    type: "text",
                    value: taskDetails.account_holder_name,
                  },
                },
                {
                  heading: "Address",
                  colSize: 6,
                  data: {
                    type: "text",
                    value:
                      taskDetails.account_holder_address +
                      " " +
                      taskDetails.account_holder_unit_or_suite +
                      " " +
                      taskDetails.account_holder_city +
                      " " +
                      taskDetails.account_holder_province_or_city +
                      " " +
                      taskDetails.account_holder_country +
                      " " +
                      taskDetails.account_holder_postal_code,
                  },
                },
                {
                  heading: "Transit Number",
                  colSize: 3,
                  data: {
                    type: "text",
                    value: taskDetails.account_holder_transit_number,
                  },
                },
                {
                  heading: "Institution Number",
                  data: {
                    type: "text",
                    value: taskDetails.account_holder_institution_number,
                  },
                },
                {
                  heading: "Account Number",
                  data: {
                    type: "text",
                    value: taskDetails.account_holder_account_number,
                  },
                },
                {
                  heading: "Effective Date",
                  data: {
                    type: "text",
                    value: taskDetails.effective_date_of_change,
                  },
                },
                {
                  heading: "Effective Time",
                  data: {
                    type: "text",
                    value: formatTime(
                      taskDetails.effective_time_of_change || ""
                    ),
                  },
                },
                {
                  heading: "Details",
                  colSize: 12,
                  data: {
                    type: "text",
                    value: taskDetails.details,
                  },
                },
              ]}
            >
              <Divider sx={{ mt: 2, mb: 2 }} />
              <Grid container>
                <Grid item xs={12} md={6}>
                  <Typography
                    variant="body1"
                    fontSize={"1.2rem"}
                    fontWeight={600}
                  >
                    Attachments
                  </Typography>
                  {attachment.length > 0 ? (
                    attachment.map((item) => {
                      return (
                        <Stack
                          key={item.key}
                          direction={"row"}
                          justifyContent={"center"}
                          gap={2}
                          alignItems={"center"}
                        >
                          <Typography
                            variant="h4"
                            textTransform={"capitalize"}
                            width={"30%"}
                          >
                            {" "}
                            {item.fileName}{" "}
                          </Typography>
                          <FileUpload value={item.url} deleteDisabled />
                        </Stack>
                      );
                    })
                  ) : (
                    <Typography variant="body1">No attachments</Typography>
                  )}
                </Grid>
              </Grid>
            </StandardCellList>
          </Grid>
        </Grid>
      )}
    </PageLoader>
  );
};
